import React from "react";
import { CollectionBuildSessionSummary } from "../../app/api/collectionBuild";
import { COLLECTION_RECENTS_EMPTY } from "./collectionBuildConstants";
import { collectionBuildSummaryTitle } from "./collectionBuildSession";
import { useCollectionBuildSessionsOptional } from "./CollectionBuildSessionsContext";
import GenerativeRecentsList, {
  GenerativeRecentItem,
} from "./shared/GenerativeRecentsList";

export const buildCollectionRecentItems = (
  summaries: CollectionBuildSessionSummary[]
): GenerativeRecentItem[] =>
  summaries
    .filter(item => Number.isInteger(item.sessionId) && item.sessionId > 0)
    .map(item => ({
      key: `collection-${item.sessionId}`,
      kind: "collection" as const,
      id: item.sessionId,
      sessionId: item.sessionId,
      title: collectionBuildSummaryTitle(item),
      status: item.status,
      createdAt: item.updatedAt || item.createdAt,
    }));

type Props = {
  items: GenerativeRecentItem[];
  activeKey: string | null;
  collapsed: boolean;
  onToggle: () => void;
  onSelect: (item: GenerativeRecentItem) => void;
};

/**
 * Collection Build Recents wiring — keep CB labels/builders here so IG Recents
 * edits do not change Collection Build sidebar behavior by accident.
 */
const CollectionBuildRecents: React.FC<Props> = ({
  items,
  activeKey,
  collapsed,
  onToggle,
  onSelect,
}) => {
  const sessions = useCollectionBuildSessionsOptional();

  return (
    <GenerativeRecentsList
      product="collection-build"
      items={items}
      activeKey={activeKey}
      collapsed={collapsed}
      emptyCopy={COLLECTION_RECENTS_EMPTY}
      onToggle={() => {
        // Accordion was the old "refresh" affordance — keep a fetch on expand,
        // but session create/save/generate also invalidate summaries elsewhere.
        if (collapsed) {
          void sessions?.refreshSummaries();
        }
        onToggle();
      }}
      onSelect={onSelect}
    />
  );
};

export default CollectionBuildRecents;
